import React from "react"
import { Modal, Form, Col, Row, Button, Table, Container } from "react-bootstrap"
import { FaChevronLeft, FaAngleDoubleLeft, FaAngleDoubleUp, FaAngleDown, FaAngleDoubleRight, FaAngleDoubleDown, FaChevronRight, FaAngleUp } from "react-icons/fa"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import DualListBox from "./DualListBox"
import Checkbox from "../Checkbox"
import AddNewLabAccountSelection from "../Invitation/LabAccountSelection"
import LabAccountListGet from "../../api/Administration/LabAccountListGet"
import LabAccount from "../../api/Administration/Model/LabAccount"
import ActivateAndInActiveLabAccountObservable from "../../api/Administration/ActivateAndInActiveLabAccount"
import ActionButton from "../ActionButton"
import { APIError } from "../../api/ObservableFromFetch"
import { IsOnTrack } from "../../App";
import ConfirmationModal from "../ConfirmationModal"

interface LabAccountSelectionProps {
  portalMode?: boolean
  locationMode?: boolean
  name: string
  implementationID: number
  accountID: number
  show: boolean
  onClose: () => void
}

interface LabAccountSelectionState {
  addNewLabAccountSelection: boolean
  loading: boolean
  saving: boolean
  selectionLeft: number[]
  selectionRight: number[]
  leftItems: LabAccount[]
  rightItems: LabAccount[]
  showConfirmSave: boolean
}

export default class LabAccountSelection extends React.PureComponent<LabAccountSelectionProps, LabAccountSelectionState> {
  subscription?: Subscription
  state: LabAccountSelectionState = {
    addNewLabAccountSelection: false,
    loading: false,
    saving: false,
    selectionLeft: [],
    selectionRight: [],
    leftItems: [],
    rightItems: [],
    showConfirmSave: false
  }

  componentDidUpdate(prevProps: LabAccountSelectionProps) {
    if (this.props.show && this.props.show !== prevProps.show) {
      this.loadLabAccounts()
    }
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  onCancel = () => {
    this.props.onClose()
    this.setState({ leftItems: [], rightItems: [],selectionLeft: [], selectionRight: [], saving:false, loading:false })
  }

  onSubmit = () => {
    if(this.state.leftItems.length === 0){
      this.saveData()
      return
    }
    const visibleLabAccounts = this.state.leftItems.filter(item => !item.HideOnOrder)
    if (visibleLabAccounts.length > 0){
      this.saveData()
    }
    else {
      this.setState({ showConfirmSave: true })
    }
  }
  saveData = () => {
    const activeLabAccounts = this.state.leftItems
    const inActiveLabAccounts = this.state.rightItems

    this.setState({ saving: true })
    this.subscription = ActivateAndInActiveLabAccountObservable(activeLabAccounts, inActiveLabAccounts).subscribe(
      data => {
        this.setState({ saving: false })
        toast.success(data)
        this.loadLabAccounts()
      },
      error => this.handleAPIError(error, { saving: false })
    )
  }
  handleConfirmSave = () => {
    this.setState({ showConfirmSave: false })
    this.saveData()
  }
  handleConfirmClose = () => {
    this.setState({ showConfirmSave: false })
  }
  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  loadLabAccounts() {
    this.setState({ loading: true })
    this.subscription = LabAccountListGet(this.props.implementationID, this.props.accountID, !!this.props.locationMode).subscribe(
      (data: { ActiveLabAccount: LabAccount[], InActiveLabAccount: LabAccount[] }) => {
        const leftItems = data.ActiveLabAccount.sort((a: LabAccount, b: LabAccount) => a.LabAccountNumber < b.LabAccountNumber ? -1 : a.LabAccountNumber > b.LabAccountNumber ? 1 : 0)
        const rightItems = data.InActiveLabAccount.sort((a: LabAccount, b: LabAccount) => a.LabAccountNumber < b.LabAccountNumber ? -1 : a.LabAccountNumber > b.LabAccountNumber ? 1 : 0)
        const availableLabAccounts = [...data.ActiveLabAccount, ...data.InActiveLabAccount].sort((a: LabAccount, b: LabAccount) => a.LabAccountNumber < b.LabAccountNumber ? -1 : a.LabAccountNumber > b.LabAccountNumber ? 1 : 0)
        this.setState({ loading: false, leftItems: leftItems, rightItems: rightItems, selectionLeft: [], selectionRight: [] })
      },
      error => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ loading: false })
      }
    )
  }
  moveLeftToRight(all: boolean) {
    const selectionLeft: number[] = []
    const ids = all ? this.state.leftItems.map(item => item.ProviderMappingID) : this.state.selectionLeft
    const leftItems = this.state.leftItems.filter(item => !ids.includes(item.ProviderMappingID))
    const newRightItems = [...this.state.rightItems, ...this.state.leftItems.filter(item => ids.includes(item.ProviderMappingID))]
    const rightItems = newRightItems.sort((a: LabAccount, b: LabAccount) => a.LabAccountNumber < b.LabAccountNumber ? -1 : a.LabAccountNumber > b.LabAccountNumber ? 1 : 0)
    this.setState({ selectionLeft: selectionLeft, leftItems: leftItems, rightItems: rightItems })
  }
  moveRightToLeft(all: boolean) {
    const selectionRight: number[] = []
    const ids = all ? this.state.rightItems.map(item => item.ProviderMappingID) : this.state.selectionRight
    const rightItems = this.state.rightItems.filter(item => !ids.includes(item.ProviderMappingID))
    const newLeftItems = [...this.state.leftItems, ...this.state.rightItems.filter(item => ids.includes(item.ProviderMappingID))]
    const leftItems = newLeftItems.sort((a: LabAccount, b: LabAccount) => a.LabAccountNumber < b.LabAccountNumber ? -1 : a.LabAccountNumber > b.LabAccountNumber ? 1 : 0)
    this.setState({ selectionRight: selectionRight, leftItems: leftItems, rightItems: rightItems })
  }
  handleLeftItemClick = (event: React.MouseEvent<HTMLElement>, id: number) => {

    if ((!event.shiftKey) && (!event.ctrlKey)) {
      const selectionLeft: number[] = [id]
      this.setState({ selectionLeft: selectionLeft })
      return
    }
    if (this.state.selectionLeft.includes(id)) {
      this.setState({ selectionLeft: this.state.selectionLeft.filter(item => item !== id) })
    } else {
      this.setState({ selectionLeft: [...this.state.selectionLeft, id] })
    }
  }
  handleRightItemClick = (event: React.MouseEvent<HTMLElement>, id: number) => {
    if ((!event.shiftKey) && (!event.ctrlKey)) {
      const selectionRight: number[] = [id]
      this.setState({ selectionRight: selectionRight })
      return
    }
    if (this.state.selectionRight.includes(id)) {
      this.setState({ selectionRight: this.state.selectionRight.filter(item => item !== id) })
    } else {
      this.setState({ selectionRight: [...this.state.selectionRight, id] })
    }
  }

  itemsTable = (data: LabAccount[], isLeft: boolean, editable: boolean = false) => {
    const { selectionLeft, selectionRight } = this.state
    return (
      <Table className="table-sm dark" borderless responsive>
        <tbody>
          {data.map(item => <tr key={"data_row_" + item.ProviderMappingID} className={isLeft ? (selectionLeft.includes(item.ProviderMappingID) ? "selected" : "") : (selectionRight.includes(item.ProviderMappingID) ? "selected" : "")}>
            <td
              onClick={(e: React.MouseEvent<HTMLElement>) => isLeft ?
                this.handleLeftItemClick(e, item.ProviderMappingID) :
                this.handleRightItemClick(e, item.ProviderMappingID)}
              style={{ userSelect: "none" }}
            >
              {item.LabAccountNumber}
            </td>
            {editable && <td className="py-0">
              <Checkbox
                id={"hide_on_order_" + item.ProviderMappingID}
                checked={item.HideOnOrder}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleHideOnOrderChange(e, item.ProviderMappingID)}
              />
            </td>}
          </tr>)}
        </tbody>
      </Table>
    )
  }
  handleHideOnOrderChange = (event: React.ChangeEvent<HTMLInputElement>, itemId: number) => {
    const selectedCode = event.target.value

    const itemIndex = this.state.leftItems.findIndex(item => item.ProviderMappingID === itemId);
    if (itemIndex < 0) {
      return
    }
    const leftItems = [...this.state.leftItems]
    leftItems[itemIndex].HideOnOrder = event.target.checked
    this.setState({ leftItems: leftItems })

  }

  render() {
    const { loading, saving, addNewLabAccountSelection, leftItems, rightItems, selectionLeft, selectionRight } = this.state
    const { portalMode, name, locationMode } = this.props
    const disabled = loading || saving
    const isOnTrack = IsOnTrack()
    const showConfirmSave = this.state.showConfirmSave


    return (
      <>
        {addNewLabAccountSelection && <AddNewLabAccountSelection cancelText="Cancel" isLabSet={false} isLoggedIn={true}
          implementationID={this.props.implementationID} accountID={this.props.accountID} isClinic={!!this.props.portalMode} isLocation={!!this.props.locationMode}
          onPrev={() => this.setState({ addNewLabAccountSelection: false })}
          onNext={() => this.setState({ addNewLabAccountSelection: false })}
          onUpdate={() => { this.setState({ addNewLabAccountSelection: false }); this.loadLabAccounts() }} />}
        {showConfirmSave &&
          <ConfirmationModal show={showConfirmSave}
            title="WARNING"
            textTitle="Please note that all accounts are marked as hidden"
            text=""
            showImage={false}
            onConfirm={() => this.handleConfirmSave()}
            onHide={() => this.handleConfirmClose()} />
        }

        <Modal backdrop="static" show={this.props.show} size="xl">
          <Modal.Header>
            <Modal.Title className="text-uppercase">Lab Accounts</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <React.Fragment>
              <Form className="px-4">
                <Form.Group as={Row}>
                  {portalMode && <Form.Label column="sm" sm={3} className="text-lg-right">Clinic</Form.Label>}
                  {!portalMode && !locationMode && <Form.Label column="sm" sm={3} className="text-lg-right">Company</Form.Label>}
                  {!!locationMode && <Form.Label column="sm" sm={3} className="text-lg-right">Location</Form.Label>}
                  <Col md={9}>
                    <Form.Control type="text" size="sm" defaultValue={name} disabled></Form.Control>
                  </Col>
                </Form.Group>

                <Form.Row>
                  <Container fluid>
                    <Row className="d-none d-lg-flex pt-4">
                      {isOnTrack && <Col lg={5}>Active Lab Accounts</Col>}
                      {!isOnTrack && <Col lg={3}>Active Lab Accounts</Col>}
                      {!isOnTrack && <Col lg={2} className="text-center">Hide On Order</Col>}
                      <Col className="px-0 text-center align-self-center"></Col>
                      <Col lg={5} className="pl-lg-0">Inactive Lab Accounts</Col>
                    </Row>
                    <Row>
                      <Col lg={5} className="px-0 border" style={{ height: "288px", overflowY: "auto" }}>
                        {this.itemsTable(leftItems, true, !isOnTrack)}
                      </Col>

                      <Col className="px-0 text-center align-self-center">
                        <Container fluid>
                          <Row>
                            <Col lg={12} xs={3} className="px-1 text-center">
                              <Button className="btn-sm btn-sm-icon mb-lg-2 mt-lg-0 my-1" disabled={!leftItems.length || disabled} onClick={() => this.moveLeftToRight(true)}>
                                <FaAngleDoubleRight className="d-none d-lg-inline" />
                                <FaAngleDoubleDown className="d-lg-none" />
                              </Button>
                            </Col>
                            <Col lg={12} xs={3} className="px-1 text-center">
                              <Button className="btn-sm btn-sm-icon mb-lg-2 mt-lg-0 my-1" disabled={!selectionLeft.length || disabled} onClick={() => this.moveLeftToRight(false)}>
                                <FaChevronRight className="d-none d-lg-inline" />
                                <FaAngleDown className="d-lg-none" />
                              </Button>
                            </Col>
                            <Col lg={12} xs={3} className="px-1 text-center">
                              <Button className="btn-sm btn-sm-icon mb-lg-2 mt-lg-0 my-1" disabled={!selectionRight.length || disabled} onClick={() => this.moveRightToLeft(false)}>
                                <FaChevronLeft className="d-none d-lg-inline" />
                                <FaAngleUp className="d-lg-none" />
                              </Button>
                            </Col>
                            <Col lg={12} xs={3} className="px-1 text-center">
                              <Button className="btn-sm btn-sm-icon mb-lg-2 mt-lg-0 my-1" disabled={!rightItems.length || disabled} onClick={() => this.moveRightToLeft(true)}>
                                <FaAngleDoubleLeft className="d-none d-lg-inline" />
                                <FaAngleDoubleUp className="d-lg-none" />
                              </Button>
                            </Col>
                          </Row>
                        </Container>

                      </Col>


                      <Col lg={5} className="px-0 border" style={{ height: "288px", overflowY: "auto" }}>
                        {this.itemsTable(rightItems, false, false)}
                      </Col>
                    </Row>
                  </Container>
                </Form.Row>

              </Form>
            </React.Fragment>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.onCancel} className="px-4">Cancel</Button>
            <Button onClick={() => this.setState({ addNewLabAccountSelection: true })} className="px-4">Add New</Button>
            <ActionButton onClick={this.onSubmit} className="px-4" spin={saving} disableOnSpin>Submit</ActionButton>
          </Modal.Footer>
        </Modal>
      </>
    )
  }

}
